import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icons from '../components/Icons';

export default function WhatsNewPage() {
  const navigate = useNavigate();
  return (
    <div className="custom-scroll page-enter" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'var(--bg)', zIndex: 9999, overflowY: 'auto' }}>
      
      <button onClick={() => navigate(-1)} style={{ position: 'absolute', top: 30, right: 30, width: 44, height: 44, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', color: 'var(--t2)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10 }}>
        <Icons.X sz={20} />
      </button>

      <div style={{ maxWidth: 700, margin: '0 auto', padding: '80px 20px', color: 'var(--t2)', lineHeight: 1.6 }}>
        
        <h1 style={{ fontSize: 40, color: 'var(--t1)', marginBottom: 12, fontWeight: 800 }}>
          What's New <span style={{ fontSize: 32 }}>✨</span>
        </h1>
        <p style={{ fontSize: 16, color: 'var(--t3)', marginBottom: 50 }}>
          Stay up to date with the latest models, tools, and updates in aiField Studio.
        </p>

        <div style={{ position: 'relative', paddingLeft: 30, borderLeft: '2px solid rgba(255,255,255,0.1)' }}>
          
          {/* April 25 Update */}
          <div style={{ position: 'relative', marginBottom: 50 }}>
            {/* Timeline dot */}
            <div style={{ 
              position: 'absolute', left: -36, top: 2, width: 14, height: 14, 
              borderRadius: '50%', background: 'var(--ac3)', border: '2px solid var(--bg)' 
            }} />
            
            <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--ac3)', marginBottom: 6, letterSpacing: 1.5 }}>LATEST • APRIL 25, 2026</p>
            <h3 style={{ fontSize: 24, color: 'var(--t1)', marginBottom: 16 }}>Seedance 2.0 Video Models Integrated ✨</h3>
            
            <div style={{ background: 'rgba(255,255,255,0.03)', padding: 20, borderRadius: 12, border: '1px solid rgba(255,255,255,0.05)', marginBottom: 16 }}>
              <p style={{ fontSize: 14, color: 'var(--t2)', margin: '0 0 16px 0' }}>
                ByteDance's most advanced cinematic video model is now fully integrated into the Studio!
              </p>
              <ul style={{ margin: 0, paddingLeft: 20, fontSize: 14, color: 'var(--t3)', display: 'flex', flexDirection: 'column', gap: 8 }}>
                <li><strong style={{ color: 'var(--t2)' }}>Text-to-Video:</strong> Generate cinematic outputs with native audio using just a text prompt.</li>
                <li><strong style={{ color: 'var(--t2)' }}>Image-to-Video:</strong> Bring still frames to life with full motion control and synchronized audio.</li>
                <li><strong style={{ color: 'var(--t2)' }}>Reference-to-Video:</strong> The ultimate director mode. Blend up to 9 images, 3 videos, and 3 audio clips for unparalleled control.</li>
                <li><strong style={{ color: 'var(--t2)' }}>Queue Infrastructure:</strong> Powered by our newly upgraded lightning-fast asynchronous job queue for maximum reliability.</li>
              </ul>
            </div>
            <div style={{ width: '100%', height: 200, borderRadius: 12, background: 'linear-gradient(45deg, #a855f7, #ec4899, #f43f5e)', opacity: 0.8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: 60 }}>🎬</span>
            </div>
          </div>

          {/* April 8 Update */}
          <div style={{ position: 'relative', marginBottom: 50 }}>
            {/* Timeline dot */}
            <div style={{ 
              position: 'absolute', left: -36, top: 2, width: 14, height: 14, 
              borderRadius: '50%', background: 'rgba(255,255,255,0.3)', border: '2px solid var(--bg)' 
            }} />
            
            <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--t3)', marginBottom: 6, letterSpacing: 1.5 }}>APRIL 8, 2026</p>
            <h3 style={{ fontSize: 20, color: 'var(--t2)', marginBottom: 16 }}>Tiered Model Access & Upgraded Infrastructure ✨</h3>
            
            <div style={{ background: 'rgba(255,255,255,0.03)', padding: 16, borderRadius: 12, border: '1px solid rgba(255,255,255,0.05)', marginBottom: 16 }}>
              <p style={{ fontSize: 14, color: 'var(--t3)', margin: '0 0 12px 0' }}>
                We've completed the rollout of our new scalable credit and subscription backend!
              </p>
              <ul style={{ margin: 0, paddingLeft: 20, fontSize: 14, color: 'var(--t3)', display: 'flex', flexDirection: 'column', gap: 8 }}>
                <li><strong style={{ color: 'var(--t2)' }}>Kling 3.0 Unlocked:</strong> The revolutionary Kling 3.0 video generation model is now available to all standard users.</li>
                <li><strong style={{ color: 'var(--t2)' }}>Premium Image Models:</strong> Flux 2 Max, Nano Banana Pro, and Seedream 5.0 are now seamlessly integrated with the Go, Plus, and Pro subscription plans.</li>
                <li><strong style={{ color: 'var(--t2)' }}>Revamped Navigation:</strong> Added a dedicated "Edit" suite grouping Upscaling, Different Angles, and Motion Sync workflows together.</li>
                <li><strong style={{ color: 'var(--t2)' }}>Fluid Reference Workflows:</strong> Lightbox correctly propagates "Use as reference" and "Recreate Image" metadata directly across modules.</li>
              </ul>
            </div>
          </div>

          {/* Previous Update */}
          <div style={{ position: 'relative', marginBottom: 50 }}>
            <div style={{ 
              position: 'absolute', left: -36, top: 2, width: 14, height: 14, 
              borderRadius: '50%', background: 'rgba(255,255,255,0.3)', border: '2px solid var(--bg)' 
            }} />
            
            <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--t3)', marginBottom: 6, letterSpacing: 1.5 }}>MARCH 2026</p>
            <h3 style={{ fontSize: 20, color: 'var(--t2)', marginBottom: 16 }}>Different Angles & Multi-Shot Video</h3>
            
            <div style={{ background: 'rgba(255,255,255,0.02)', padding: 16, borderRadius: 12, border: '1px solid rgba(255,255,255,0.03)' }}>
              <p style={{ fontSize: 14, color: 'var(--t3)', margin: '0 0 12px 0' }}>
                Major feature drop focused on directional control and temporal consistency.
              </p>
              <ul style={{ margin: 0, paddingLeft: 20, fontSize: 14, color: 'var(--t3)', display: 'flex', flexDirection: 'column', gap: 8 }}>
                <li>Introduced an interactive 3D Orbital Camera tool for precise Pan, Tilt, and Zoom adjustments.</li>
                <li>Enabled Multi-Shot video generation natively within the Kling 3.0 interface.</li>
                <li>Seamless 1024px Image compression engine pushed to all reference uploads.</li>
              </ul>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}
